import { brandConfig } from 'brand-config';

/**
 * Hook to access brand-specific feature flags
 * @returns {Object} Feature flags for the current brand
 * @returns {boolean} hasFutureEffectiveDateDiscount - Whether the brand supports FED discount
 * @returns {boolean} hasAdvanceQuoteDiscount - Whether the brand supports AQD discount
 */
function useBrandFeatures() {
  const features = brandConfig?.features || {};

  return {
    hasFutureEffectiveDateDiscount: features.hasFutureEffectiveDateDiscount ?? true,
    hasAdvanceQuoteDiscount: features.hasAdvanceQuoteDiscount ?? true
  };
}

export default useBrandFeatures;
